import { render, staticRenderFns } from "./settingPage.vue?vue&type=template&id=4b82dfb8&scoped=true"
import script from "./settingPage.vue?vue&type=script&lang=js"
export * from "./settingPage.vue?vue&type=script&lang=js"
import style0 from "./settingPage.vue?vue&type=style&index=0&id=4b82dfb8&prod&lang=scss"
import style1 from "./settingPage.vue?vue&type=style&index=1&id=4b82dfb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b82dfb8",
  null
  
)

export default component.exports